<template>
   <div class="bg-light pt-3 pt-lg-5 pb-5">
      <b-container fluid>
         <b-row>
            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>

            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">
               <h5>Editar Perfil</h5>

               <el-divider content-position="left">Meus Atalhos</el-divider>

               <b-row class="mt-4">
                  <b-col cols="12" md="4" class="mb-3 mb-lg-0">
                     <el-button
                        class="w-100"
                        size="mini"
                        type="info"
                        :round="true"
                        @click="() => this.$router.push({name: 'verificacoes'})"
                     >
                        Verificações
                     </el-button>
                  </b-col>
                  <b-col cols="12" md="4">
                     <el-button
                        class="w-100"
                        size="mini"
                        type="info"
                        :round="true"
                        @click="() => this.$router.push({name: 'security'})"
                     >
                        Alterar Senha
                     </el-button>
                  </b-col>
               </b-row>


               <el-alert
                  v-if="ready === false"
                  title="Complete seu perfil!"
                  type="info"
                  description="Estamos muitos felizes por você compartilhar experiências conosco. Para você usar todos os recursos da plataforma Pedale, por favor, complete o seu perfil com suas informações, para que sua experiência seja ainda mais personalizada."
                  show-icon
                  :closable="false"
               >
               </el-alert>

               <el-alert
                  v-if="redirectedByNotVerifiedPhone === false"
                  title="ATENÇÃO: Verifique o número do seu telefone"
                  type="error"
                  description="Para continuar usando os serviços da nossa plataforma, por favor, verifique o número do seu telefone."
                  effect="dark"
                  :closable="false"
                  class="mt-3"
               >
               </el-alert>
               <hr>
               <b-row class="mt-4">

                  <!-- ====== Personal data | Dados Pessoais ====== -->
                  <b-col cols="12" lg="8">

                     <el-card class="box-card dashboard-card pb-0">
                        <div slot="header" class="clearfix">
                           <span>Dados Cadastrais</span> <i v-if="loading.dataUser" class="el-icon-loading"></i>

                           <el-button
                              v-if="false"
                              :disabled="editProfile"
                              class="text-primary"
                              @click="editProfile = true"
                              style="float: right; padding: 3px 10px"
                              :type="!editProfile ? 'defauld' : 'primary'"
                              icon="el-icon-edit">
                              Editar Dados
                           </el-button>

                        </div>

                        <el-alert
                           title="Os campos com * são obrigatórios"
                           type="info"
                           closable
                           class="mb-3"
                        >
                        </el-alert>

                        <el-form
                           :model="user"
                           :rules="userRules"
                           ref="user"
                           class="checkout-form dashboard-form pl-1 pr-1 pt-1"
                           size="small"
                           v-loading="loading.dataUser"
                        >

                           <!-- Nome e Razão Social da Empresa  -->
                           <b-row v-if="isPJ">

                              <b-col lg="6" class="pr-3 pr-lg-0">
                                 <el-form-item label="Nome da Empresa" prop="additionalInformation.businessName">
                                    <el-input
                                       @change="editProfile = true"
                                       type="text"
                                       v-model="user.additionalInformation.businessName"
                                       placeholder="Informe o Nome da Empresa"></el-input>
                                 </el-form-item>
                              </b-col>

                              <b-col lg="6">
                                 <el-form-item label="Razão Social" prop="additionalInformation.corporateName">
                                    <el-input
                                       @change="editProfile = true"
                                       type="text"
                                       v-model="user.additionalInformation.corporateName"
                                       placeholder="Informe a Razão Social"></el-input>
                                 </el-form-item>
                              </b-col>

                           </b-row>

                           <!-- Name and CPF | Nome e CPF -->
                           <el-row :gutter="20">

                              <el-col :span="24" :sm="12">
                                 <el-form-item :label="isPJ ? 'Nome do Responsável' : 'Nome'" prop="firstName">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.firstName"></el-input>
                                 </el-form-item>
                              </el-col>

                              <el-col :span="24" :sm="12">
                                 <el-form-item :label="isPJ ? 'Sobrenome do Responsável' : 'Sobrenome'" prop="lastName">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.lastName"></el-input>
                                 </el-form-item>
                              </el-col>

                           </el-row>

                           <!-- E-mail e CPF -->
                           <el-row :gutter="20">

                              <el-col :span="24" :sm="12">
                                 <el-form-item label="E-mail" prop="email">
                                    <el-input v-model="user.email"></el-input>
                                 </el-form-item>
                              </el-col>

                              <el-col :span="24" :sm="12">
                                 <el-form-item :label="isPJ ? 'CNPJ' : isPF ? 'CPF' : 'Passaporte'" prop="additionalInformation.cpf">
                                    <el-input
                                       type="text"
                                       disabled
                                       v-model="user.additionalInformation.cpf"
                                       ></el-input>
                                 </el-form-item>
                              </el-col>
                           </el-row>

                           <!-- Telefone -->
                           <div class="text-primary">* Telefone (celular)</div>
                           <el-row :gutter="20" class="validate-phone">
                              <el-col :span="8" :sm="5">
                                 <el-form-item>
                                    <el-input
                                       type="text"
                                       :value="user.additionalInformation.internationalPhoneAreaCode"
                                       v-model="user.additionalInformation.internationalPhoneAreaCode"
                                    ></el-input>
                                 </el-form-item>
                              </el-col>
                              <el-col :span="16" :sm="9">
                                 <el-form-item  prop="additionalInformation.phone">
                                    <el-input
                                       @change="changePhoneNumber"
                                       :masked="false"
                                       v-mask="user.additionalInformation.type === 'passport' ? null : ['(##) ####-####', '(##) #####-####']"
                                       v-model="user.additionalInformation.phone"
                                       :placeholder="user.additionalInformation.type === 'passport' ? '' : '(99) 99999-9999'"
                                       :maxlength="user.additionalInformation.type === 'passport' ? 15 : null"
                                       @input="onPhoneInput"
                                    ></el-input>
                                 </el-form-item>
                              </el-col>
                              <el-col :span="24" :sm="10">
                                 <el-form-item>
                                    <el-button
                                       @click="validateNumber"
                                       :type="user.additionalInformation.verifiedPhone ? 'primary' : 'blue'"
                                       :plain="user.additionalInformation.verifiedPhone"
                                       size="mini"
                                       class="text-uppercase font-weight-bold w-100 btn-validate"
                                       :loading="loading.validateNumber"
                                       :disabled=" this.loading.dataUser || user.additionalInformation.verifiedPhone || !user.additionalInformation.phone"
                                    >
                                       <span v-if="user.additionalInformation.verifiedPhone">
                                          <i class="el-icon-circle-check mr-1"></i> Número Verificado
                                       </span>
                                       <span v-else>
                                          Verificar Número
                                       </span>

                                    </el-button>
                                 </el-form-item>
                              </el-col>
                           </el-row>


                           <!-- Gênero -->
                           <el-row v-if="!isPJ" :gutter="20">
                              <el-col :span="24">
                                 <el-form-item label="Genero" prop="additionalInformation.gender" >
                                    <el-select
                                       class="mb-0"
                                       @change="editProfile = true"
                                       v-model="user.additionalInformation.gender"
                                       placeholder="Selecione">
                                       <el-option
                                          v-for="gender in genderOptions"
                                          :key="gender.value"
                                          :label="gender.label"
                                          :value="gender.value">
                                       </el-option>
                                    </el-select>
                                 </el-form-item>
                              </el-col>

                           </el-row>

                           <el-divider v-if="isPJ" class="mb-4 mt-3" content-position="center">Endereço da Empresa</el-divider>

                           <!-- CEP - Preenchido automaticamente via cep -->
                           <el-row :gutter="20">
                              <el-col :span="16" :sm="20">

                                 <el-form-item label="CEP" prop="address.cep">
                                    <el-input
                                       @change="getCep"
                                       :maxlength="9"
                                       v-mask="'#####-###'"
                                       v-model="user.address.cep"
                                       :clearable="true"
                                    >
                                       <i v-if="loading.cep" slot="suffix"
                                          class="el-input__icon el-icon-loading"></i>
                                    </el-input>
                                 </el-form-item>
                              </el-col>
                              <el-col :span="6" :sm="4" class="find-cep-link">
                                 <el-link class="small" @click="findZip = true" target="_blank"
                                          title="Clique aqui para buscar">Não sabe?
                                 </el-link>
                              </el-col>
                           </el-row>

                           <!-- Endereço -->
                           <el-row :gutter="20">

                              <el-col :span="24" :sm="18">
                                 <el-form-item label="Rua / Avenida" prop="address.street">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.address.street"></el-input>
                                 </el-form-item>
                              </el-col>

                              <el-col :span="24" :sm="6">
                                 <el-form-item label="Número" prop="address.number">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.address.number"></el-input>
                                 </el-form-item>
                              </el-col>

                           </el-row>

                           <!-- Complemento e Bairro -->
                           <el-row :gutter="20">
                              <el-col :span="24" :sm="15">
                                 <el-form-item label="Complemento" prop="address.complement">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.address.complement"></el-input>
                                 </el-form-item>
                              </el-col>
                              <el-col :span="24" :sm="9">
                                 <el-form-item label="Bairro" prop="address.district">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.address.district"></el-input>
                                 </el-form-item>
                              </el-col>
                           </el-row>

                           <!-- Cidade e Estado com preenchimento automatico via cep -->
                           <el-row :gutter="20">

                              <el-col :span="24" :sm="12">
                                 <el-form-item label="Cidade" prop="address.city">
                                    <el-input
                                       @change="editProfile = true"
                                       v-model="user.address.city"
                                    ></el-input>
                                 </el-form-item>
                              </el-col>

                              <el-col :span="24" :sm="12" class="v-select-label">
                                 <el-form-item label="Estado" prop="address.state">
                                    <v-select
                                       @search:blur="editProfile = true"
                                       @search:focus="getStates"
                                       :clearable="false"
                                       :options="ufs"
                                       v-model="user.address.state"
                                       placeholder="Selecione..."
                                    >
                                       <template #no-options="">
                                          Estado não encontrado
                                       </template>
                                    </v-select>
                                 </el-form-item>
                              </el-col>



                           </el-row>

                           <!-- Submit -->
                           <b-row class="mt-1">
                              <b-col cols="12">
                                 <el-form-item class="mb-0">
                                    <el-button
                                       @click="() => submitInfoForm('user')"
                                       :disabled="!editProfile"
                                       :round="true"
                                       :loading="loading.btnUserInfo"
                                       type="primary"
                                       size="mini"
                                       class="text-uppercase font-weight-bold w-100"
                                    >
                                       Salvar
                                    </el-button>
                                 </el-form-item>
                              </b-col>
                              <b-col  v-if="false" cols="4">
                                 <el-form-item>
                                    <el-button

                                       :disabled="editProfile"
                                       @click="editProfile = false"
                                       :round="true"
                                       :loading="false"
                                       type="info"
                                       plain
                                       size="mini"
                                       class="text-uppercase font-weight-bold  w-100"
                                    >
                                       Cancelar
                                    </el-button>
                                 </el-form-item>
                              </b-col>
                           </b-row>
                        </el-form>
                     </el-card>

                  </b-col>


                  <!-- ====== Photo and Description | Foto e Descrição ====== -->
                  <b-col cols="12" lg="4" class="mt-4 mt-lg-0">

                     <el-card class="box-card dashboard-card">

                        <div slot="header">
                           <span v-if="isPJ">Logomarca</span>
                           <span v-else>Perfil </span>
                        </div>
                        <div class="avatar-wrap">
                           <ImageUpload v-loading="loading.dataUser"
                                        :imageUri="avatarUri"></ImageUpload>
                        </div>


                        <small style="line-height: 18px" class="text-muted d-block ">Dimensões: 256X256px. Tamanho máximo: 512kb</small>
                        <!-- BIOGRAFIA -->
                        <el-form
                           v-loading="loading.dataUser" :model="userBio" ref="userBio"
                           class="dashboard-form"
                           size="small">
                           <b-row class="text-center text-xl-left">
                              <b-col cols="12" class="mt-3">
                                 <h6 class="small d-inline">Biografia</h6>
<!--                                 <el-button
                                    v-show="!editBio"
                                    @click="editBio = true"
                                    style="float: right; padding: 3px 0"
                                    type="text"
                                    icon="el-icon-edit">
                                    Editar
                                 </el-button>-->

                                 <el-form-item>
                                    <el-input
                                       type="textarea"
                                       v-model="userBio.description"
                                       :rows="6"
                                       maxlength="1024"
                                       show-word-limit
                                       @focus="editBio = true"
                                    ></el-input>
                                 </el-form-item>

                                 <el-form-item>
                                    <el-button
                                       @click="submitBioForm('userBio')"
                                       :disabled="!editBio"
                                       :round="true"
                                       :loading="loading.btnUserBio"
                                       :type="editBio ? 'primary' : 'info'"
                                       size="mini"
                                       class="text-uppercase font-weight-bold"
                                    >
                                       Salvar
                                    </el-button>

                                       <!--<el-button
                                          :disabled="!editBio"
                                          @click="editBio = false"
                                          :round="true"
                                          :loading="false"
                                          type="info"
                                          plain
                                          size="mini"
                                          class="text-uppercase font-weight-bold">
                                       Cancelar
                                       </el-button>-->
                                 </el-form-item>


                                 <div class="mt-2">
                                    <small class="text-muted">Fique tranquilo: aqui seus dados estão seguros e
                                    nós respeitamos seus direitos. Confira nossa <router-link
                                       class=""
                                       to="/politicas-pedale">Política de Privacidade
                                    </router-link>.</small>
                                 </div>


                              </b-col>

                           </b-row>
                        </el-form>
                     </el-card>

                     <br>
                     <p>Se você deseja excluir a sua conta, clique no botão abaixo:</p>
                     <el-button
                        @click="deleteAccount()"
                        size="small"
                        type="danger"
                        plain
                        class="mt-2 d-block font-weight-bold"
                        round>Deletar conta
                     </el-button>
                  </b-col>

               </b-row>


            </b-col>
         </b-row>
      </b-container>

      <!-- Modal Descubra o teu cep-->
      <el-dialog
         title="Descubra o teu cep"
         :visible.sync="findZip"
         width="30%"
         top="30px"
         class="el-dialog--no-header modal-responsive"
      >
         <h5>Buscar CEP</h5>
         <p>Após localizado, copie ou anote o cep, feche esta janela e cole ou digite o cep no campo "CEP" do
            formulário.</p>
         <iframe width="100%" height="400" src="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                 title="Buscar CEP - Correios"></iframe>

         <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="() => this.findZip = false">Fechar Janela</el-button>
      </span>
      </el-dialog>

      <!-- Modal Verificação de Número-->
      <el-dialog
         title="Verificação de Número"
         :visible.sync="dialogValidateNumber"
         :before-close="dialogValidateNumberClose"
         width="40%"
         class="modal-responsive"
         :close-on-click-modal="false"
         :close-on-press-escape="false"
      >

         <p>Enviamos um código de 6 dígitos para o número informado. Por favor, digite o código abaixo:</p>

         <el-form
            :model="validateNumberCode"
            :rules="validateNumberCodeRules"
            ref="validateNumberCode"
            class="mt-4"
         >
            <el-form-item prop="code">
               <el-input
                  size="lg"
                  @change="editProfile = true"
                  :disabled="loading.btnValidateCode || loading.btnResendCode"
                  v-model="validateNumberCode.code"></el-input>
            </el-form-item>

         <span class="dialog-footer d-flex justify-content-between">
             <el-button
                :loading="loading.btnValidateCode || loading.sendingCode"
                :disabled="loading.btnResendCode"
                type="blue"
                class="mt-sm-2 ml-lg-0 ml-xl-2"
                @click="submitNumberCode('validateNumberCode')"
             >
                <span v-if="loading.sendingCode">Enviando Código...</span>
                <span v-else>Validar Código</span>

             </el-button>

             <el-button
                class="mt-sm-2 ml-lg-0 ml-xl-2"
                :disabled="loading.btnValidateCode || loading.btnResendCode || btnValidateCodeResend"
                :loading="loading.btnResendCode"
                @click="reSendCode"
             >
                <span v-if=" loading.btnResendCode">Enviando...</span>
                <span v-else>Reenviar Código</span>

                <span v-if="countDown > 0"> ({{countDown}})</span></el-button>

        </span>

         </el-form>
      </el-dialog>

   </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
import ImageUpload from "@/components/ImageUpload";
import { onlyNumber, validarCNPJ, checkPhone } from "@/helpers";
import Permission from "@/helpers/Permission";
import isCpf from '@/helpers/cpf';
import user from '@/models/User';
import header from "@/services/header";
import SiteService from "@/services/site.service";
import UserService from '@/services/user.service';
import { mask } from 'vue-the-mask';


export default {
   name: 'Profile',
   components: {
      DashUserNav,
      ImageUpload,
   },
   directives: {mask},
   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         file: '',
         user: user,
         userOk: false,
         loading: {
            cep: false,
            btnUserInfo: false,
            btnUserBio: false,
            dataUser: true,
            saveAvatar: false,
            validateNumber: false,
            btnValidateCode: false,
            btnResendCode: false,
            global: false,
            sendingCode: false
         },
         editProfile: false,
         editBio: false,
         avatarTempUrl: '',
         genderOptions: [
            {value: 'male', label: 'Masculino'},
            {value: 'female', label: 'Feminino'},
            {value: 'other', label: 'Outros'},
         ],
         userRules: {
            firstName: [
               {required: true, message: 'Por favor, digite seu Nome', trigger: 'blur'},
            ],
            lastName: [
               {required: true, message: 'Por favor, digite seu Sobrenome', trigger: 'blur'},
            ],
            email: [
               {required: true, message: 'Por favor, digite seu E-mail', trigger: 'blur'},
               {type: 'email', message: 'Digite um e-mail válido!', trigger: ['blur', 'change']}
            ],
            additionalInformation: {
               phone: [
                  {required: false, message: 'Por favor, digite seu telefone', trigger: 'blur'},
                  {validator: this.checkPhoneHandler, trigger: 'blur'},
               ],
               cpf: [
                  {required: true, message: 'Por favor, digite seu CPF', trigger: 'blur'},
                  {validator: this.checkCpf, trigger: 'blur'},
               ],
               gender: [
                  {required: true, message: 'Por favor, selecione o gênero', trigger: 'blur'},
               ],
               countryCod: [
                  {required: false, message: 'Código do Pais', trigger: 'blur'},
               ],
               businessName: [
                  {required: true, message: 'Digite o nome da Empresa', trigger: 'blur'}
               ],
               corporateName: [
                  {required: true, message: 'Digite a Razão Social', trigger: 'blur'}
               ],
            },
            address: {
               cep: [
                  {required: true, message: 'Por favor, digite sua rua, avenina, estrada, etc', trigger: 'blur'},
                  {validator: this.checkCep, trigger: 'blur'},
               ],
               street: [
                  {required: true, message: 'Por favor, digite seu Endereço', trigger: 'blur'},
               ],
               number: [
                  {required: true, message: 'Digite o Número', trigger: 'blur'},
               ],
               complement: [
                  {required: false, message: 'Por favor, digite seu complemento', trigger: 'blur'},
               ],
               district: [
                  {required: true, message: 'Por favor, digite seu Bairro', trigger: 'blur'},
               ],
               city: [
                  {required: true, message: 'Por favor, digite seu Cidade', trigger: 'blur'},
               ],
               state: [
                  {required: true, message: 'Por favor, digite seu Estado', trigger: 'blur'},
               ],
            },
         },
         userBio: {
            description: '',
         },
         userAvatar: null,
         avatarUri: null,
         avatarSaveBtn: false,
         findZip: false,
         ready: true,
         countryCod: '+55',
         dialogValidateNumber: false,
         validateNumberCode: {
            code: null
         },
         validateNumberCodeRules: {
            code: [
               {required: true, message: 'Por favor, digite o código', trigger: 'blur'},
            ],
         },
         btnValidateCodeResend: true,
         countDown: 0,
         firstCodeSubmission: false,
         isChangePhoneNumber: false,
         redirectedByNotVerifiedPhone: false,
         ufs: [],
      }
   },
   async mounted() {

      this.loading.dataUser = true;
      await this.getUser();

      if (!this.currentUser) {
         await this.$router.push('/login')
      }

      this.ready = new Permission(this.user).userIsReady()

   },

   methods: {

      deleteAccount() {

         this.$confirm('Você está prestes a excluir a sua conta. Você está certo disso? Todos os seus dados salvos na plataforma Pedale serão excluído e essa ação é irreversível.', 'ATENÇÃO', {
            confirmButtonText: 'Sim, quero excluir minha conta',
            cancelButtonText: 'Cancelar',
            type: 'danger'
         }).then(() => {
            this.deleteUser( this.user._id )
         })
      },

      checkPhoneHandler(rule, value, callback) {
         if (this.user.additionalInformation.type !== 'passport') {
            checkPhone(rule, value, callback)
         } else {
            return callback()
         }
      },


      async deleteUser(_id) {
         await UserService.deleteUser(_id)
         this.logOut()
      },

      logOut() {
         this.$loading({
            lock: true,
            text: 'Excluindo conta e removendo seus dados...',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
         });
         setTimeout(() => {

            this.$store.dispatch('user/clear')

            if (localStorage.getItem('user')) {
               try {
                  localStorage.removeItem('user');
                  this.$router.go('/login');
               } catch(e) {
                  this.$router.go('/login');
               }
            }

            // loading.close();
         }, 1000);
      },

      //Obtem os dados do usuário.
      async getUser() {

         await this.$store.dispatch('user/get', await UserService.getUserData())
         this.user = this.userData.data
         if (this.user) {
            await this.getStates(this.user.address.state)
         }
         this.loading.dataUser = false;
      },

      //Envio do formulário Informações de Cobrança
      submitInfoForm(formName) {

         this.$refs[formName].validate((valid) => {
            this.loading.btnUserInfo = true;
            this.loading.dataUser = true;

            if (valid) {
               if (this.isChangePhoneNumber) {
                  this.user.additionalInformation.verifiedPhone = false
               }


               const data = this.user;
               data._id = this.currentUser.user._id;

               this.axios.put(`${this.baseUrl + this.apiV1}/user/update`, {data}, header)
                  .then((response) => {
                     this.$message({
                        message: response.data.message,
                        type: 'success'
                     });
                     this.loading.btnUserInfo = false;
                     this.editProfile = false;
                     this.loading.dataUser = false;
                     // this.getUser();
                     this.ready = new Permission(this.user).userIsReady()


                  })
                  .catch(() => {
                     this.loading.btnUserInfo = false;
                     this.editProfile = false;
                     this.loading.dataUser = false;
                  });
            } else {
               this.$message({
                  message: "Preencha todos os campos corretamente!",
                  type: 'warning'
               });
               this.loading.btnUserInfo = false;
               this.loading.dataUser = false;
               return false;
            }
         });
      },

      //Envio do formulário Informações de Cobrança
      submitBioForm(formName) {
         this.$refs[formName].validate((valid) => {
            this.loading.btnUserBio = true;

            if (valid) {
               const data = {description: this.userBio.description};
               this.axios.put(`${this.baseUrl + this.apiV1}/user/update/bio`, {data}, header,)
                  .then((response) => {
                     this.$message({
                        message: response.data.message,
                        type: 'success'
                     });
                     this.loading.btnUserBio = false;
                     this.editBio = false;

                  })
                  .catch(err => {
                     this.$message.error(err.response.data.message);
                     this.loading.btnUserBio = false;
                     this.editBio = false;
                  });
            } else {
               this.loading.btnUserBio = false;
               return false;
            }
         });
      },

      checkCpf(rule, value, callback) {

         const docType = this.user.additionalInformation.type === 'pf' ? 'CPF' : 'CNPJ'

         if (!value) {
            return callback(new Error(`Por favor, inform seu ${docType}`));
         }

         const cpf = onlyNumber(value);

         let isCNPJ = cpf.length > 11 || false

         if (!isCNPJ && this.user.additionalInformation.type === 'pf') {
            if (!isCpf(cpf)) {
               return callback(new Error('CPF Inválido'));
            }
         }

         if (this.user.additionalInformation.type === 'pj') {
            if (!validarCNPJ(cpf)) {
               return callback(new Error('CNPJ Inválido'));
            }
         }



         if (isCNPJ) {
            if (!validarCNPJ(cpf)) {
               return callback(new Error('CNPJ Inválido'));
            }
         }

         callback();
      },

      checkPhone(rule, value, callback) {
         var phoneno = /^\(\d{2}\) 9\d{4}-\d{4}|\((?:1[2-9]|[2-9]\d)\) [5-9]\d{3}-\d{4}$/

         if (!value) {
            return callback(new Error('Por favor, digite seu telefone'));
         }

         if(value.match(phoneno)) {
            callback();
         }
         else {
            return callback(new Error('Telefone inválido'));
         }


      },

      //Pega o CEP do ViaCep https://viacep.com.br/
      async getCep(cep) {
         this.loading.cep = true;
         const res = await this.axios.get(`https://viacep.com.br/ws/${cep}/json/`)
         if (res) {
            this.user.address.street = res.data.logradouro;
            this.user.address.district = res.data.bairro;
            this.user.address.city = res.data.localidade;
            this.loading.cep = false;
            this.editProfile = true;
            await this.getStates(res.data.uf)
         }

      },


      //Faz validações no campo do CEP.
      checkCep(rule, value, callback) {
         if (value.length !== 9) {
            callback(new Error('Digite os 8 digitos do cep'));
         }

         callback();
      },

      resetForm(formName) {
         this.$refs[formName].resetFields();
      },

      changePhoneNumber() {
         this.editProfile = true
         this.isChangePhoneNumber = true
         this.user.additionalInformation.verifiedPhone = false
      },

      async validateNumber() {
         this.loading.validateNumber = true
         this.dialogValidateNumber = true

         if (this.countDown > 1) {
            return false
         } else {
            this.loading.sendingCode = true
            await this.sendCode()
         }

      },

      async sendCode() {
         try {

            const phone = this.countryCod + onlyNumber(this.user.additionalInformation.phone)

            await UserService.valNumberSendCode(phone)
            this.loading.btnResendCode = false
            this.btnValidateCodeResend = true
            this.loading.sendingCode = false
            this.countDown = 60
            this.countDownTimer()

            this.$message({
               message: "O Código Pedale foi enviado para o seu celular.",
               type: 'success'
            });

         } catch (e) {
            this.$message({
               message: "Solicitação indisponível no momento. Tente novamente mais tarde.",
               type: 'danger'
            });
         }

      },

      async reSendCode() {
         try {
            this.loading.btnResendCode = true
            this.validateNumberCode.code = null
            this.loading.btnResendCode = true
            this.loading.sendingCode = true

            await this.sendCode()
            this.loading.btnResendCode = false
            this.btnValidateCodeResend = true
            this.countDown = 60
            this.countDownTimer()

         } catch (e) {
            this.$message({
               message: "Não foi possível enviar o código. Tente novamente mais tarde.",
               type: 'danger'
            });
         }

      },

      submitNumberCode(formName) {
         this.$refs[formName].validate(async (valid) => {
            this.loading.btnValidateCode = true;

            if (valid) {

                  try {
                     await UserService.valNumberVerifyCode(this.validateNumberCode.code)

                     this.$message({
                        message: "Número verificado com sucesso! Obrigado.",
                        type: 'success'
                     });

                     this.user.additionalInformation.verifiedPhone = true
                     this.isChangePhoneNumber = false
                     this.loading.btnValidateCode = false
                     this.loading.validateNumber = false
                     this.dialogValidateNumber = false
                     this.redirectedByNotVerifiedPhone = true

                     const data = this.user;
                     data._id = this.currentUser.user._id;

                    await this.axios.put(`${this.baseUrl + this.apiV1}/user/update`, {data}, header)

                     await this.getUser()

                  } catch (e) {
                     this.loading.btnValidateCode = false;
                     this.loading.validateNumber = false
                  }

            } else {
               this.$message({
                  message: "Por favor, informe o código!",
                  type: 'warning'
               });
               this.loading.btnValidateCode = false;
               return false;
            }
         });
      },

      dialogValidateNumberClose() {
         this.loading.validateNumber = false
         this.dialogValidateNumber = false
         this.btnValidateCodeResend = true
         setTimeout(() => {
            if (!this.btnValidateCodeResend) {
               this.countDown = 60
            }

         }, 100)
      },

      countDownTimer() {
         if(this.countDown > 0) {
            setTimeout(() => {
               this.countDown -= 1
               this.countDownTimer()
            }, 1000)
         } else {
            this.btnValidateCodeResend = false
         }
      },

      async getStates(uf) {
         let arr = []

         if ( this.ufs.length === 0 ) {
            const ufs = await SiteService.getUfs();

            if (ufs) {
               ufs.data.map(obj => {
                  arr.push({id: obj.id, label: obj.nome, value: obj.sigla})
               })
               this.ufs = arr;
               if (uf) {
                  let selectedUf = arr.filter(i => i.value === uf)
                  this.user.address.state = selectedUf[0]
               }
               return true
            }
         } else {
            let selectedUf = this.ufs.filter(i => i.value === uf)

            this.user.address.state = selectedUf[0]
         }
      },

      onPhoneInput(event) {
         // Permitir apenas números e limitar a 15 dígitos
         if (this.user.additionalInformation.type === 'passport') {
            this.user.additionalInformation.phone = event.replace(/\D/g, '').slice(0, 15);
         }
      }
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user
      },
      isPJ() {
         return this.$store.state.user.data.additionalInformation.type === 'pj' || false
      },
      isPF() {
         return this.$store.state.user.data.additionalInformation.type === 'pf' || false
      },
   },
   watch: {

      //Watcher para popuplar o avatar do usuário no perfil.
      'user.description': function (n) {
         this.userBio.description = n;
      },

      '$route': {
         handler: function (page) {
            this.redirectedByNotVerifiedPhone = page.params.verifiedPhone
         },
         deep: true,
         immediate: true
      }
   }

};
</script>

<style lang="scss">
   .dashboard-card {
      overflow: visible;
   }
</style>
